export default "__VITE_ASSET__BtKzXu6d__"